import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import { useEffect, useState } from 'react';
import VnButton from '@ui/components/VnButton';
import { IonIcon } from '@ionic/react';
import { calendarOutline, glassesOutline } from 'ionicons/icons';
import { selectStyles } from '@ui/styles/select-style';
import VnSelectText from '@ui/components/VnSelectText';
import { Link, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllBrandsAsync } from '@application/features/brands/BrandThunk';
import moment from 'moment';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { createOrderLineAsync, deleteOrderLineAsync, getAllArticalsAsync, getArticalByIdAsync, getOrderLineByIDAsync, updateOrderLineAsync } from '@application/features/orderlines/orderLineThunk';
import AsyncSelect from 'react-select/async';
import { getWorkOrdersListWithClientAsync } from '@application/features/orderlines/orderLineThunk';
import VnValidation from '@ui/components/VnValidation';
import { getAllWorkOrdersByIdAsync } from '@application/features/workorders/workorderThunk';
import { getAllArticlesAsync } from '@application/features/articles/ArticleThunk';
import ModalPopup from '@ui/components/VnModal';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import ArticleTableForm from '@ui/containers/admin/workOrder/ArticleTableForm';
import VnPagination from '@ui/components/VnPagination';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { NumericFormat } from 'react-number-format';
import { handleRolePermission } from '@infrastructure/helpers';
const AddOrderLineForm = ({ onClose, orderLineId, disableRecord, onOrderLineGridUpdate, handleOrderStatusChange, formData }) => {
    const { setValue, handleSubmit, register, watch, control, clearErrors, formState: { errors } } = useForm({
        defaultValues: {
            receivedDate: new Date(),
            netPrice: 0
        }
    });
    const dispatch = useAppDispatch();
    const { ArticlesDropDown, Articles } = useAppSelector((state) => state.orderLine);
    const { articles } = useAppSelector((state) => state.artical);
    const { brandsBrandLableDropdown, brandsUnitDropdown } = useAppSelector((state) => state.brands);
    const [articleNumber, setArticleNumber] = useState('');
    const [selectedArticalId, setSelectedArticalId] = useState('');
    const [brand, setBrand] = useState('');
    const [orderLineReceivedDate, setOrderLineRecievedDate] = useState(new Date());
    const [receivedDatePickerOpen, setReceivedDateIsOpen] = useState(false);
    const [isOrderLineDeletePopup, setisOrderLineDeletePopup] = useState(false);
    const [selectedWorkOrderValue, setSelectedWorkOrderValue] = useState();
    const [isToogled, setIsToggled] = useState(false);
    const quantity = watch('quantity');
    const netPrice = watch('netPrice');
    const sellingPrice = watch('sellingPrice');
    const [isArticleTableOpen, setIsArticleTableOpen] = useState(false);
    const [showArticleGridHeader] = useState(true);
    const { WorkOrderListWithClientOptions } = useAppSelector((state) => state.orderLine);
    const { id } = useParams();
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [isRecievedToggleValue, setIsReceivedToggleValue] = useState(false);
    const { Order } = useAppSelector((state) => state.order);
    const defaultSortingCriteria = {
        sortColumnKey: 'articleNumber',
        sortDirection: 'desc'
    };
    const [articlesFilterValues, setArticlesFilterValues] = useState({
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        articleNumber: null,
        name: null,
        articleGroup: null,
        brand: null,
        type: null,
        data: null,
        supplierName: null,
        unit: null,
        supplierArticleNumber: null,
        grossPrice: null,
        discount: null,
        netPrice: null,
        sellingPrice: null,
        priceDate: null,
        stock: null
    });
    useEffect(() => {
        if (quantity && netPrice) {
            const total = quantity * netPrice;
            setValue('totaaldebrag', total);
        }
        else {
            setValue('totaaldebrag', 0);
        }
    }, [quantity, netPrice]);
    const unitPrice = watch('unitPrice');
    const discount = watch('discount');
    const workOrderId = watch('workOrderId');
    useEffect(() => {
        if (id) {
            dispatch(getAllArticalsAsync());
            dispatch(getAllBrandsAsync());
        }
    }, [dispatch, id]);
    useEffect(() => {
        if (orderLineId > 0) {
            setArticleNumber('');
            setValue('name', '');
            setValue('type', '');
            setBrand('');
            setValue('receivedDate', new Date());
            setValue('details', '');
            setValue('supplierProductNumber', '');
            setValue('unit', '');
            setValue('unitPrice', 0);
            setValue('discount', 0);
            setValue('netPrice', 0);
            setValue('sellingPrice', 0);
            setValue('quantity', 0);
            setValue('workOrderId', 0);
            dispatch(getOrderLineByIDAsync(orderLineId))
                .unwrap()
                .then((res) => {
                const articalName = Articles?.find((x) => x.articleNumber === res.articleNumber)?.name;
                if (res.articleNumber && res.articleNumber.trim() !== '' && articalName && articalName.trim() !== '') {
                    setArticleNumber(res.articleNumber + ' - ' + articalName);
                }
                else {
                    setArticleNumber(res.articleNumber ?? '');
                }
                setSelectedArticalId(res.articleId?.toString() ?? '');
                setValue('name', res.name);
                setValue('type', res.type);
                setIsToggled(res.received);
                setIsReceivedToggleValue(res.received);
                setReceivedDateonGetByIdCall(res);
                setBrand(res.brand ?? '');
                setValue('details', res.details);
                setValue('supplierProductNumber', res.supplierProductNumber);
                setValue('quantity', res.quantity);
                setValue('unit', res.unit);
                setValue('unitPrice', res.unitPrice);
                setValue('discount', res.discount);
                setValue('netPrice', res.netPrice);
                setValue('sellingPrice', res.sellingPrice);
                setValue('workOrderId', res.workOrderId);
                setValue('received', res.received);
                setSelectedWorkOrderValue(res.workOrderId);
                if (res.workOrderId)
                    dispatch(getAllWorkOrdersByIdAsync(res.workOrderId))
                        .unwrap()
                        .then((res) => {
                        workOrderAsyncList(res.workOrderNumber);
                    })
                        .catch((error) => {
                        console.error('Bad request.');
                    });
            });
        }
    }, [dispatch, orderLineId]);
    function setReceivedDateonGetByIdCall(res) {
        if (res.receivedDate) {
            setOrderLineRecievedDate(moment(res.receivedDate).toDate());
            setValue('receivedDate', new Date(moment(res.receivedDate).format('YYYY-MM-DD')));
        }
        else {
            setOrderLineRecievedDate(null);
            setValue('receivedDate', null);
        }
    }
    function onArticalNumberChange(selectedValue, selectedLable) {
        setArticleNumber(selectedLable);
        setSelectedArticalId(selectedValue);
        if (selectedValue && selectedValue !== '') {
            setValue('name', '');
            setValue('type', '');
            setBrand('');
            setOrderLineRecievedDate(moment(new Date()).toDate());
            setValue('details', '');
            setValue('supplierProductNumber', '');
            setValue('unit', '');
            setValue('unitPrice', 0);
            setValue('discount', 0);
            setValue('netPrice', 0);
            setValue('sellingPrice', 0);
            setValue('quantity', 0);
            dispatch(getArticalByIdAsync(parseInt(selectedValue)))
                .unwrap()
                .then((res) => {
                setValue('name', res.name);
                setValue('type', res.type);
                setBrand(res.brand ?? '');
                setValue('brand', res.brand ?? '');
                setValue('supplierProductNumber', res.supplierArticleNumber);
                setValue('unit', res.unit);
                setValue('unitPrice', res.grossPrice);
                setValue('discount', res.discount);
                setValue('netPrice', res.netPrice);
                setValue('sellingPrice', res.sellingPrice);
            });
            clearErrors('name');
        }
    }
    const onSubmit = (data) => {
        if (id && orderLineId === 0) {
            data.orderId = parseInt(id);
            if (selectedArticalId && selectedArticalId.trim() !== '') {
                data.articleId = parseInt(selectedArticalId);
                data.articleNumber = Articles?.find((x) => x.id === parseInt(selectedArticalId))?.articleNumber;
            }
            else {
                data.articleNumber = articleNumber;
            }
            data.brand = brand;
            dispatch(createOrderLineAsync(data))
                .unwrap()
                .then((res) => {
                onClose();
                handleOrderStatusChange();
                onOrderLineGridUpdate();
            })
                .catch((error) => {
                console.error('Bad request.');
            });
        }
        else if (id && orderLineId > 0 && !disableRecord) {
            data.id = orderLineId;
            data.orderId = parseInt(id);
            if (selectedArticalId && selectedArticalId.trim() !== '') {
                data.articleId = parseInt(selectedArticalId);
                data.articleNumber = Articles?.find((x) => x.id === parseInt(selectedArticalId))?.articleNumber;
            }
            else {
                data.articleNumber = articleNumber;
            }
            data.brand = brand;
            dispatch(updateOrderLineAsync(data))
                .unwrap()
                .then((res) => {
                onClose();
                handleOrderStatusChange();
                onOrderLineGridUpdate();
            })
                .catch((error) => {
                console.error('Bad request.');
            });
        }
    };
    const handleOrderLineReceivedDateChange = (date) => {
        setOrderLineRecievedDate(moment(date).toDate());
        setReceivedDateIsOpen(false);
        setValue('receivedDate', date);
    };
    const openOrderLineReceivedDatePicker = () => {
        setReceivedDateIsOpen(!receivedDatePickerOpen);
    };
    function onBrandChange(selectedValue, selectedLable) {
        setBrand(selectedLable);
        setValue('brand', selectedLable);
    }
    function workOrderAsyncList(inputValue) {
        if (inputValue.length > 2) {
            return dispatch(getWorkOrdersListWithClientAsync(inputValue))
                .unwrap()
                .then((res) => {
                const options = res.map((workOrder) => ({
                    label: workOrder.workOrderNumber,
                    value: workOrder.id
                }));
                return options;
            });
        }
        return Promise.resolve([]);
    }
    function handleToggle(toggleValue) {
        if (!isRecievedToggleValue) {
            setIsToggled(toggleValue);
            setValue('received', toggleValue);
        }
    }
    const deleteOrderLine = () => {
        setisOrderLineDeletePopup(true);
    };
    const onCancelDeleteClicked = () => {
        setisOrderLineDeletePopup(false);
    };
    const onDeleteClicked = () => {
        dispatch(deleteOrderLineAsync(orderLineId))
            .unwrap()
            .then(() => {
            onClose();
            setisOrderLineDeletePopup(false);
            dispatch(getOrderLineByIDAsync(parseInt(id)));
        })
            .catch((error) => {
            console.error('Bad request.');
        });
    };
    const updateArticlesFilterValues = (newValues) => {
        setArticlesFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchArticleHandler(searchText) {
        updateArticlesFilterValues({ filter: searchText });
        dispatch(getAllArticlesAsync({
            ...articlesFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function articlesSortingHandler(data) {
        updateArticlesFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllArticlesAsync({
            ...articlesFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function articlesFilteringHandler(data) {
        data.pageNumber = 1;
        updateArticlesFilterValues(data);
        dispatch(getAllArticlesAsync({
            ...articlesFilterValues,
            ...data
        }));
    }
    useEffect(() => {
        dispatch(getAllArticlesAsync(articlesFilterValues));
    }, []);
    function onArticlesPageChange(pageNumber) {
        updateArticlesFilterValues({ pageNumber });
        dispatch(getAllArticlesAsync({
            ...articlesFilterValues,
            pageNumber
        }));
    }
    const handleAddArticleRowClick = (data) => {
        if (id && data) {
            const updatedArticleRowData = {
                ...data,
                orderId: parseInt(id),
                id: 0,
                receivedDate: new Date(),
                supplierProductNumber: data.supplierArticleNumber,
                details: data.data,
                unitPrice: data.grossPrice
            };
            const articalName = Articles?.find((x) => x.articleNumber === updatedArticleRowData.articleNumber)?.name;
            if (updatedArticleRowData.articleNumber &&
                updatedArticleRowData.articleNumber.trim() !== '' &&
                articalName &&
                articalName.trim() !== '') {
                setArticleNumber(`${updatedArticleRowData.articleNumber} - ${articalName ?? ''}`);
            }
            else {
                setArticleNumber(updatedArticleRowData.articleNumber ?? '');
            }
            setSelectedArticalId(updatedArticleRowData.articleId?.toString() ?? '');
            setValue('name', updatedArticleRowData.name);
            setValue('type', updatedArticleRowData.type);
            setIsToggled(updatedArticleRowData.received);
            setIsReceivedToggleValue(updatedArticleRowData.received);
            setReceivedDateonGetByIdCall(updatedArticleRowData);
            setBrand(updatedArticleRowData.brand ?? '');
            setValue('details', updatedArticleRowData.details);
            setValue('supplierProductNumber', updatedArticleRowData.supplierProductNumber);
            setValue('quantity', updatedArticleRowData.quantity);
            setValue('unit', updatedArticleRowData.unit);
            setValue('unitPrice', updatedArticleRowData.unitPrice);
            setValue('discount', updatedArticleRowData.discount);
            setValue('netPrice', updatedArticleRowData.netPrice);
            setValue('sellingPrice', updatedArticleRowData.sellingPrice);
            setValue('workOrderId', updatedArticleRowData.workOrderId);
            setValue('received', updatedArticleRowData.received);
            setSelectedWorkOrderValue(updatedArticleRowData.workOrderId);
            if (updatedArticleRowData.workOrderId)
                dispatch(getAllWorkOrdersByIdAsync(updatedArticleRowData.workOrderId))
                    .unwrap()
                    .then((res) => {
                    workOrderAsyncList(res.workOrderNumber);
                })
                    .catch((error) => {
                    console.error('Bad request.');
                });
        }
    };
    //---------------Handling bruto,korting,neto and vekop price logic-----------------------
    const triggerUpdatedPricesLogic = () => {
        if (isInitialLoad) {
            setIsInitialLoad(false);
        }
    };
    useEffect(() => {
        if (!isInitialLoad) {
            if (unitPrice && discount) {
                // Case 2: When both gross price and discount change, calculate net price and set selling price
                const calculatedNetPrice = unitPrice - (unitPrice * discount) / 100;
                setValue('netPrice', calculatedNetPrice);
                setValue('sellingPrice', unitPrice);
            }
            if (unitPrice && !discount) {
                //case 1 When gross price changes, set selling price and clear net price
                setValue('sellingPrice', unitPrice);
                setValue('netPrice', unitPrice);
            }
        }
    }, [unitPrice, discount, isInitialLoad]);
    useEffect(() => {
        if (!isInitialLoad) {
            if (!unitPrice && !discount && netPrice) {
                // Case 3: When only net price changes, calculate selling price as net price + 30%
                const calculatedSellingPrice = (netPrice / 70) * 100;
                setValue('sellingPrice', calculatedSellingPrice);
            }
        }
    }, [netPrice, isInitialLoad]);
    //---------------End of region handling bruto,korting,neto and vekop price logic-----------------------
    return (_jsxs(_Fragment, { children: [_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: isArticleTableOpen ? 'vn-hide' : 'Vn-form-FormMain', noValidate: true, children: [_jsxs("div", { className: 'row', children: [_jsx("div", { className: 'col-md-6', children: _jsxs("span", { className: 'Vn-form-SpeedSpan', children: [_jsxs("label", { className: 'Vn-toggle-button-switch', children: [_jsx("input", { type: 'checkbox', checked: isToogled, onChange: (e) => handleToggle(e.target.checked) }), _jsx("span", { className: 'Vn-toggle-button-slider Vn-toggle-button-round' })] }), _jsx("span", { className: 'Vn-form-text ml-2', children: "Ontvangen" })] }) }), _jsxs("div", { className: 'form-group col-md-6 mt-2', children: [_jsx("label", { className: 'form-label vn-text-label' }), !orderLineId && (_jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: glassesOutline, onClick: () => {
                                            setIsArticleTableOpen(true);
                                        }, children: "Zoek Artikelen" }))] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Artikelnummer" }), _jsx(VnSelectText, { valueOptions: ArticlesDropDown, value: articleNumber, onOptionChange: onArticalNumberChange, listtype: 'articleNumber', placeHolder: 'Selecteer artikelnummer' })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsxs("label", { className: 'form-label vn-text-label', children: ["Naam", _jsx("span", { className: 'vn-AsterikMark', children: "*" })] }), _jsx("input", { id: 'name', type: 'text', placeholder: 'Voer naam in', className: 'form-control vn-Input', ...register('name', {
                                            required: 'Dit veld is verplicht'
                                        }) }), _jsx(VnValidation, { fieldError: errors.name })] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Merk" }), _jsx(VnSelectText, { lableOptions: brandsBrandLableDropdown, value: brand, onOptionChange: onBrandChange, listtype: 'brand', placeHolder: 'Selecteer merk' })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Type" }), _jsx("input", { id: 'type', type: 'text', placeholder: 'Voer type in', className: 'form-control vn-Input', ...register('type') })] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [workOrderId ? (_jsxs(Link, { className: 'vn-anchor-style', target: '_blank', to: `/admin/WorkordersTabs/${workOrderId}`, children: ["Werkorder", _jsx("span", { className: 'vn-AsterikMark', children: "*" })] })) : (_jsxs(Link, { className: 'vn-anchor-style', to: '', children: ["Werkorder ", formData.isWorkOrderLinked == false && _jsx("span", { className: 'vn-AsterikMark', children: "*" })] })), _jsxs("div", { className: 'mt-8', children: [_jsx(Controller, { name: 'workOrderId', control: control, rules: {
                                                    required: formData.isWorkOrderLinked === false ? 'Dit veld is verplicht' : false
                                                }, render: ({ field: { onChange, value } }) => (_jsx(AsyncSelect, { name: 'workOrderId', styles: selectStyles, value: WorkOrderListWithClientOptions?.find((c) => c.value == selectedWorkOrderValue), onChange: (selectedOption) => {
                                                        setValue('workOrderId', selectedOption.value);
                                                        setSelectedWorkOrderValue(selectedOption?.value ? selectedOption?.value.toString() : '');
                                                    }, loadOptions: workOrderAsyncList, isDisabled: formData.isWorkOrderLinked == true && selectedWorkOrderValue == null ? true : false, placeholder: 'Selecteer...' })) }), selectedWorkOrderValue ? '' : _jsx(VnValidation, { fieldError: errors.workOrderId })] })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Datum Ontvangen" }), _jsx(Controller, { name: 'receivedDate', control: control, 
                                        // rules={{
                                        //     required: {
                                        //         value: true,
                                        //         message: 'This field is required.'
                                        //     }
                                        // }}
                                        render: () => (_jsxs("div", { className: 'input-group', children: [_jsx(DatePicker, { className: 'form-control vn-Input', onInputClick: openOrderLineReceivedDatePicker, open: receivedDatePickerOpen, onClickOutside: openOrderLineReceivedDatePicker, placeholderText: '', peekNextMonth: true, showPopperArrow: true, dropdownMode: 'select', dateFormat: 'dd/MM/yyyy', selected: orderLineReceivedDate, onChange: handleOrderLineReceivedDateChange, onKeyDown: (e) => {
                                                        e.preventDefault();
                                                    } }), _jsx("div", { className: 'input-group-append', children: _jsx(IonIcon, { icon: calendarOutline, className: 'vn-Datepicker-Icon', onClick: openOrderLineReceivedDatePicker }) })] })) })] })] }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'form-group col-md-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Gegevens" }), _jsx("textarea", { className: 'vn-Input', ...register('details'), style: { height: 150, width: '100%', borderRadius: '3px' } })] }) }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Aantal" }), _jsx(Controller, { name: 'quantity', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { className: 'form-control vn-Input', placeholder: 'Voer aantal in', value: value || '', onValueChange: ({ value }) => {
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    onChange(inputValue);
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] }), _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Eenheid" }), _jsx(Controller, { name: 'unit', control: control, render: ({ field: { onChange, value } }) => (_jsx(Select, { placeholder: 'Eenheid', isSearchable: true, styles: selectStyles, value: brandsUnitDropdown?.find((c) => c.label === value), options: brandsUnitDropdown && brandsUnitDropdown, onChange: (val) => onChange(val?.label) })) })] })] }), _jsxs("div", { className: 'row mt-4', children: [_jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Bruto Prijs" }), _jsx(Controller, { name: 'unitPrice', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat
                                        // type='number'
                                        , { 
                                            // type='number'
                                            placeholder: 'Voer bruto prijs in', className: 'form-control vn-Input', value: value || '', 
                                            // min='0'
                                            onValueChange: ({ value }) => {
                                                if (value != unitPrice?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                    setValue('sellingPrice', 0);
                                                    setValue('netPrice', 0);
                                                }
                                                else {
                                                    // const regex = /^[0-9]*\.?[0-9]{0,2}$/;
                                                    // if (regex.test(inputValue) || inputValue === '') {
                                                    onChange(inputValue);
                                                    // }
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Korting" }), _jsx(Controller, { name: 'discount', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat
                                        // type='number'
                                        , { 
                                            // type='number'
                                            className: 'form-control vn-Input', placeholder: 'Voer korting in', value: value || '', 
                                            // min='0'
                                            onValueChange: ({ value }) => {
                                                if (value != discount?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    // const regex = /^[0-9]*\.?[0-9]{0,2}$/;
                                                    // if (regex.test(inputValue) || inputValue === '') {
                                                    onChange(inputValue);
                                                    // }
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 100) })) })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Netto Prijs" }), _jsx(Controller, { name: 'netPrice', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat
                                        // type='number'
                                        , { 
                                            // type='number'
                                            disabled: !unitPrice && !discount ? false : true, className: 'form-control vn-Input', placeholder: '', value: value?.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 
                                            // min='0'
                                            onValueChange: ({ value }) => {
                                                if (value != unitPrice?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    // const regex = /^[0-9]*\.?[0-9]{0,2}$/;
                                                    // if (regex.test(inputValue) || inputValue === '') {
                                                    onChange(inputValue);
                                                    // }
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] }), _jsxs("div", { className: 'form-group col-md-3', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Verkoopprijs" }), _jsx(Controller, { name: 'sellingPrice', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat
                                        // type='number'
                                        , { 
                                            // type='number'
                                            className: 'form-control vn-Input', placeholder: 'Voer verkoopprijs in', value: value || '', 
                                            // min='0'
                                            onValueChange: ({ value }) => {
                                                if (value != sellingPrice?.toString()) {
                                                    triggerUpdatedPricesLogic();
                                                }
                                                const inputValue = value;
                                                if (inputValue === '') {
                                                    onChange(null);
                                                }
                                                else {
                                                    // const regex = /^[0-9]*\.?[0-9]{0,2}$/;
                                                    // if (regex.test(inputValue) || inputValue === '') {
                                                    onChange(inputValue);
                                                    // }
                                                }
                                            }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false, isAllowed: ({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 999999.99) })) })] })] }), _jsx("div", { className: 'row mt-4', children: _jsxs("div", { className: 'form-group col-md-6', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Totaal Bedrag" }), _jsx(Controller, { name: 'totaaldebrag', control: control, render: ({ field: { onChange, value } }) => (_jsx(NumericFormat, { disabled: true, className: 'form-control vn-Input', placeholder: '', value: value?.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), onValueChange: ({ value }) => {
                                            const inputValue = value;
                                            if (inputValue === '') {
                                                onChange(null);
                                            }
                                            else {
                                                onChange(inputValue);
                                            }
                                        }, thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, allowNegative: false })) })] }) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', isDisabled: disableRecord, children: "Annuleren" }), orderLineId > 0 ? (_jsxs(_Fragment, { children: [_jsx(VnButton, { style: { marginLeft: '8px' }, customClassName: 'vn-popup-delete-button', mode: 'danger', type: 'button', onClick: () => deleteOrderLine(), isDisabled: !handleRolePermission(Permission.BESTELLINGEN, PermissionType.Delete) ||
                                                disableRecord ||
                                                isRecievedToggleValue, children: "Verwijderen" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.BESTELLINGEN, PermissionType.Update) || disableRecord, children: "Opslaan" })] })) : (_jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.BESTELLINGEN, PermissionType.Create) || disableRecord, children: "Opslaan" }))] }) })] }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isOrderLineDeletePopup }), _jsx(ModalPopup, { title: 'Zoek Artikelen', content: _jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: showArticleGridHeader, onSearch: searchArticleHandler }), _jsx(ArticleTableForm, { OnAddArticlePopupClose: () => setIsArticleTableOpen(false), onAddMaterialPopupClose: onClose, articals: articles?.items, onSorting: articlesSortingHandler, onFilter: articlesFilteringHandler, defaultSortingCriteria: defaultSortingCriteria, onRowClick: handleAddArticleRowClick }), _jsx("div", { className: 'mt-3', children: articles && (_jsx(VnPagination, { currentPage: articles?.pageNumber, totalPages: articles?.totalPages, onPageChange: onArticlesPageChange })) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsx("div", { style: { display: 'flex', marginLeft: 'auto' }, children: _jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: () => {
                                        onClose();
                                        setIsArticleTableOpen(false);
                                    }, type: 'button', children: "Annuleren" }) }) })] }), onOpen: isArticleTableOpen, onClose: () => {
                    setIsArticleTableOpen(false);
                    onClose();
                }, modalWidth: 'xl' })] }));
};
export default AddOrderLineForm;
